import { render, staticRenderFns } from "./FormCmp.vue?vue&type=template&id=9889ce52&scoped=true"
import script from "./FormCmp.vue?vue&type=script&lang=js"
export * from "./FormCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889ce52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9889ce52')) {
      api.createRecord('9889ce52', component.options)
    } else {
      api.reload('9889ce52', component.options)
    }
    module.hot.accept("./FormCmp.vue?vue&type=template&id=9889ce52&scoped=true", function () {
      api.rerender('9889ce52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimsReviewRules/cmp/FormCmp.vue"
export default component.exports